import {DialogTitle} from '@apps-common/ui-components';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from '@mui/material';
import {bool, func, string} from 'prop-types';
import React from 'react';

const DeleteModal = ({
  description,
  isPending,
  onClose,
  onDelete,
  open,
  title,
}) => {
  return (
    <Dialog open={open} fullWidth maxWidth="sm" onClose={onClose}>
      <DialogTitle onClose={onClose} title={title} />
      <DialogContent>
        <Typography>{description}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined">
          Cancel
        </Button>
        <Button
          color="error"
          variant="contained"
          disabled={isPending}
          onClick={onDelete}
          startIcon={<DeleteOutlineIcon />}
        >
          {isPending ? 'Deleting...' : 'Delete'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

DeleteModal.propTypes = {
  onClose: func,
  open: bool,
  title: string,
  description: string,
  onDelete: func,
  isPending: bool,
};

export default DeleteModal;
